import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { RestApiService } from '../shared/restApiServices/restapi.service';
import { Router } from '@angular/router';
import { DefineAreaModalComponent } from "../define-area-modal/define-area-modal.component";

@Component({
    selector: 'access-dialog',
    templateUrl: 'access-dialog.html',
    styleUrls: ['access-dialog.css']
})
export class AccessSurveyservice {
    teamList = [];
    user: string;
    result: any;
    noTeamCreated: boolean;
    showLoader: boolean;
    constructor(private router: Router, private dialog:MatDialog,
        public dialogRef: MatDialogRef<AccessSurveyservice>, public restApiService: RestApiService, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.showLoader = true
        // this.noTeamCreated = true;
        this.user = localStorage.getItem("username");
        this.restApiService.getGroupListWithDetailsForAdminService(this.data.qID).subscribe(
            result => {
                if (result.success == true) {
                    if (result.groups.length > 0) {
                        this.noTeamCreated = false;
                        result = result.groups;
                        this.result = result;
                        for (var i in result) {
                            if (result[i].qIDs.includes(this.data.qID)) {
                                this.teamList.push({ name: result[i].teamName, "teamID": result[i].id, "defined_area" : result[i].defined_area ,created: result[i].createdAt, manager: result[i].manager, status: 'SELECTED' })
                            }
                            else {
                                this.teamList.push({ name: result[i].teamName, "teamID": result[i].id, "defined_area" : result[i].defined_area ,created: result[i].createdAt, manager: result[i].manager, status: 'SELECT' })
                            }
                        }
                        this.showLoader = false;
                    }
                    else {
                        this.showLoader = false;
                        this.noTeamCreated = true;
                    }
                }
                else {
                    // console.log(result);
                }
            });
    }
    assignTeam(data) {
        this.result[data].qNames.push(this.data.surveyName);
        this.result[data].qIDs.push(this.data.qID);
        // do not assign or unassign team if qID is null..
        if(this.result[data].qIDs.includes(null) || this.result[data].qIDs.includes(undefined) || this.result[data].qIDs.includes('undefined')){
            return;
        }
        this.restApiService.assignSurveysToGroupService(this.result[data].uIDs, this.result[data].teamName, this.result[data].qNames, this.result[data].qIDs).subscribe(
            result => {
                if (result.success != false) {
                    this.teamList[data].status = 'SELECTED';
                }
                else {
                    console.log(result.msg);
                }
            });
    }
    createTeam() {
        this.dialogRef.close();
        this.router.navigateByUrl('/groups');
    }
    unassignTeam(data) {
        var index = this.result[data].qIDs.indexOf(this.data.qID);
        if (index != -1) {
            this.result[data].qNames.splice(index, 1);
            this.result[data].qIDs.splice(index, 1);
        }
        // do not assign or unassign team if qID is null..
        if(this.result[data].qIDs.includes(null)|| this.result[data].qIDs.includes(undefined) || this.result[data].qIDs.includes('undefined')){
            return;
        }
        this.restApiService.assignSurveysToGroupService(this.result[data].uIDs, this.result[data].teamName, this.result[data].qNames, this.result[data].qIDs).subscribe(
            result => {
                if (result.success != false) {
                    this.teamList[data].status = 'SELECT';
                }
                else {
                    console.log(result.msg);
                }
            });
    }
    close() {
        this.dialogRef.close();
    }

    defineAreaForSurvey(row){
        if(row.status == "SELECTED")
        {
          let dialogRef = this.dialog.open(DefineAreaModalComponent, {
            height: '600px',
            width: '88rem',
            data: {"qID" : this.data.qID,"teamID" : row.teamID}
          })
          dialogRef.afterClosed().subscribe(result=>{
            // console.log(result);
          })
        }
      }
}



// WEBPACK FOOTER //
// ./src/app/questionnaires/AccessSurveyservice.ts